import {default as ISTMJPO} from "./JourneesPortesOuvertes/Form"
import {default as ISTMWebinar} from "./Webinar/Form"
import {default as ISTMContact} from "./Contact/Form"
import {default as ISTMDocumentation} from "./Documentation/Form"
import { CssBaseline } from "@mui/material"
import { ThemeProvider } from "@mui/material/styles"
import {FormContextProvider} from "hooks/useForm"
import Forms from "../Forms"
import theme from "./Theme/index"


const JourneesPortesOuverteISTM = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <ISTMJPO />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const WebinarISTM = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <ISTMWebinar />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const ContactISTM = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <ISTMContact />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

const DocumentationISTM = () => {
  return (
    <FormContextProvider>
      <ThemeProvider theme={theme}>
        <Forms>
          <CssBaseline />
          <ISTMDocumentation />
        </Forms>
      </ThemeProvider>
    </FormContextProvider>
  )
}

export { ContactISTM, DocumentationISTM, JourneesPortesOuverteISTM, WebinarISTM }

